import * as Yup from "yup";

// The field names below must match the formik state (firstname, lastname,
// email, department_id). The previous schema referenced `departement`
// which never matched anything and silently allowed anything through.
export const validationSchemaUpdateCollaborator = Yup.object().shape({
  firstname: Yup.string(),
  lastname: Yup.string(),
  email: Yup.string().email("validation.email"),
  department_id: Yup.mixed().nullable(),
});
